import { useQuery } from "react-query";
import { getJudgePhaseProjects, getProjectsAssignedByIdJudge } from "../../services/scientific/judgePhaseProject";
import { PagedRequestType } from "../../types/PagedResults";
import { Key_judgePhaseProjects, Key_projects } from "../../utils/constants";


export const useGetJudgePhaseProjectsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_judgePhaseProjects, JSON.stringify(data)],
    () => getJudgePhaseProjects(data),
    options?{...options}:{}
  );

export const useGetProjectsAssignedByIdJudge = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_projects, JSON.stringify(data)],
    () => getProjectsAssignedByIdJudge(data),
    options?{...options}:{}
  );
